//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'RestoreCodeModal',
  props: {
    jobId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      email: ''
    }
  },
  methods: {
    async resendCode () {
      await this.$axios.post('/api/jobs/resend-code', {
        email: this.email
      }).catch((resp) => {
        console.log(resp.data)
      })
      this.$toast.success(this.$t('submitted'))
      this.$modal.hide('restore-code-modal')
    }
  }
}
